import Api from './base';
import fetch from 'isomorphic-fetch';

export default class AudioApi extends Api {
  followShow(showId, followerId) {
    return this.request('POST', `${this.baseUrl}/api/1.0/show/${showId}/follow`, { followerId }, this.headers);
  }

  unfollowShow(showId, followerId) {
    return this.request('POST', `${this.baseUrl}/api/1.0/show/${showId}/unfollow`, { followerId }, this.headers);
  }

  createShow({ itunesId, episodeCount, userId }) {
    return this.request('POST', `${this.baseUrl}/api/1.0/show`, { itunesId, episodeCount, userId }, this.headers);
  }

  getShow(showId) {
    return this.request('GET', `${this.baseUrl}/api/1.0/show/${showId}`, null, this.headers);
  }

  getShows(type, limit) {
    return this.request('GET', `${this.baseUrl}/api/1.0/shows?type=${type}&limit=${limit}`, null, this.headers);
  }

  fetchShowsByGenre(genre) {
    return this.request('GET', `${this.baseUrl}/api/1.0/shows/genre/${genre}`, null, this.headers);
  }

  fetchShowsById(showIds) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/shows/featured`,
      {
        showIds,
      },
      this.headers
    );
  }

  fetchUserFollowedShows(userId) {
    return this.request('GET', `${this.baseUrl}/api/1.0/shows/user/follow?userId=${userId}`, null, this.headers);
  }

  getFeaturedPlaylists() {
    return this.request('GET', `${this.baseUrl}/api/1.0/playlists/featured`, null, this.headers);
  }

  queryShowsAndEpisodes(userId, query, from, size, order) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/home/search`,
      {
        userId,
        query,
        from,
        size,
        order,
      },
      this.headers
    );
  }

  updateEpisode(episodeId, data) {
    return this.request('PUT', `${this.baseUrl}/api/1.0/episode/${episodeId}`, data, this.headers);
  }

  getEpisodesOld(showId, limit) {
    return this.request('GET', `${this.baseUrl}/api/1.0/show/${showId}/episodes?limit=${limit}`, null, this.headers);
  }

  getEpisodes(userId, showId, from, size, order) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/episode/query`,
      {
        userId,
        showId,
        from,
        size,
        order,
      },
      this.headers
    );
  }

  getEpisode(episodeId) {
    return this.request('GET', `${this.baseUrl}/api/1.0/episode/${episodeId}`, null, this.headers);
  }

  searchEpisodesInShow(userId, showId, query, from, size, order) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/show/${showId}/query`,
      {
        userId,
        query,
        from,
        size,
        order,
      },
      this.headers
    );
  }

  recordEpisodeListen(userId, showId, episodeId, browserData, episodeData, sessionData) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/episode/${episodeId}/listen`,
      {
        userId,
        showId,
        browserData,
        episodeData,
        sessionData,
      },
      this.headers
    );
  }

  lookupPodcast(podcastId) {
    return this.request(
      'GET',
      `https://itunes.apple.com/lookup?id=${parseInt(podcastId)}&entity=podcast`,
      null,
      this.headers
    );
  }

  podcastCharts(chartUrl) {
    return fetch(chartUrl);
  }

  createClipp({ userId, start, end, input, output, title, imageUrl, showId, episodeId }) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/clipps`,
      {
        userId,
        start,
        end,
        input,
        output,
        title,
        imageUrl,
        showId,
        episodeId,
      },
      this.headers
    );
  }

  getClippsForEpisode({ userId, episodeId, query, from, size, order }) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/episode/${episodeId}/clipps`,
      {
        userId,
        query,
        from,
        size,
        order,
      },
      this.headers
    );
  }

  getClippsForShow({ userId, showId, query, from, size, order }) {
    return this.request(
      'POST',
      `${this.baseUrl}/api/1.0/show/${showId}/clipps`,
      {
        userId,
        query,
        from,
        size,
        order,
      },
      this.headers
    );
  }
}
